import { render } from "./EditProviderDialog.vue?vue&type=template&id=5b5487bf&scoped=true"
import script from "./EditProviderDialog.vue?vue&type=script&lang=js"
export * from "./EditProviderDialog.vue?vue&type=script&lang=js"

import "./EditProviderDialog.vue?vue&type=style&index=0&id=5b5487bf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5487bf"]])

export default __exports__